
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { iller, ilceler } from '../components/routesData';
import default_img from "./images/default_img.jpg"

// API Adresi
const URL = process.env.REACT_APP_API_URL;
const API_BASE_URL = URL+"/api";

// Rota Kartı Bileşeni (Güncellendi)
const RotaKarti = ({ rota, isStarted, isCompleted }) => {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(`/rotalar/${rota.id}`);
    };

    const defaultImage = default_img;
return (
    <div
        onClick={handleClick}
        className="group relative rounded-xl overflow-hidden shadow-md hover:shadow-2xl hover:scale-[1.03] transition-transform duration-300 cursor-pointer bg-gradient-to-b from-gray-800 via-gray-900 to-black border border-gray-700"
    >
        {/* Rota Görseli */}
        <div className="relative h-48 md:h-56 overflow-hidden">
            <img
                src={`${rota.gorsel}` || defaultImage}
                alt={rota.baslik}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
            />
            {/* Rota Tipi Etiketi */}
            <div className="absolute top-3 left-3 bg-indigo-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-lg">
                {rota.is_public ? 'Sistem Rotası' : 'Kullanıcı Rotası'}
            </div>
            {/* Rota Durumu Etiketi */}
            {isCompleted ? (
                <div className="absolute top-3 right-3 bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md flex items-center gap-1">
                    <i className="fas fa-check-circle text-xs"></i> Tamamlandı
                </div>
            ) : (
                isStarted && (
                    <div className="absolute top-3 right-3 bg-yellow-400 text-gray-900 text-xs font-semibold px-3 py-1 rounded-full shadow-md flex items-center gap-1 animate-pulse">
                        <i className="fas fa-play text-xs"></i> Başlatıldı
                    </div>
                )
            )}
        </div>

        {/* Rota Detayları */}
        <div className="p-4 md:p-5 space-y-3">
            <h3 className="text-xl md:text-2xl font-bold text-teal-400 group-hover:text-teal-300 transition-colors duration-200">
                {rota.baslik}
            </h3>
            <p className="text-sm text-gray-400 font-medium flex items-center gap-2">
                <i className="fas fa-map-marker-alt text-indigo-400"></i> {rota.il}, {rota.ilce}
            </p>
            <div className="mt-3">
                <h4 className="text-sm font-semibold text-gray-300 border-b border-gray-700 pb-1 mb-2">
                    İçerdiği Yapılar:
                </h4>
                <ul className="list-none space-y-1 text-gray-400 text-sm">
                    {rota.icerdiğiYapılar?.slice(0, 3).map((yapi, index) => (
                        <li key={index} className="flex items-center gap-2">
                            <i className="fas fa-dot-circle text-xs text-indigo-500"></i> {yapi}
                        </li>
                    ))}
                    {rota.icerdiğiYapılar?.length > 3 && (
                        <li className="italic text-xs text-gray-500 mt-1">...ve daha fazlası</li>
                    )}
                </ul>
            </div>
            <button className="w-full mt-4 bg-indigo-600 text-white font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 transition-all duration-200">
                Detayları Gör
            </button>
        </div>
    </div>
);

};

// Ana Rota Oluşturucu Sayfası Bileşeni
const RotaOlusturucuSayfasi = () => {
    const navigate = useNavigate();

    const [tumRotalar, setTumRotalar] = useState([]);
    const [secilenIl, setSecilenIl] = useState('');
    const [secilenIlce, setSecilenIlce] = useState('');
    const [filtreliRotalar, setFiltreliRotalar] = useState([]);
    const [secilenRotaTipi, setSecilenRotaTipi] = useState('all');
    const [mevcutIlceler, setMevcutIlceler] = useState([]);
    const [yukleniyor, setYukleniyor] = useState(true);
    const [hata, setHata] = useState(null);
    // Başlatılmış ve tamamlanmış rotaların durumunu tutan Map
    const [userRotaStatusMap, setUserRotaStatusMap] = useState(new Map()); 

    // Kullanıcı ID'sini token'dan alma
    const getUserIdFromToken = () => {
        const token = localStorage.getItem('token');
        if (!token) return null;
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const payload = JSON.parse(atob(base64));
            return payload.user_id;
        } catch (e) {
            console.error("Token çözümlenemedi:", e);
            return null;
        }
    };
    const currentUserId = getUserIdFromToken();

    // Kullanıcının başlatılmış rotalarını ve tamamlanma durumlarını çekme fonksiyonu
    const fetchUserRotaStatuses = useCallback(async () => {
        if (!currentUserId) {
            setUserRotaStatusMap(new Map()); // Kullanıcı yoksa haritayı temizle
            return;
        }
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setUserRotaStatusMap(new Map());
                return;
            }
            const response = await axios.get(`${API_BASE_URL}/users/${currentUserId}/started-rotas`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const statusMap = new Map();
            response.data.forEach(sr => {
                statusMap.set(sr.rota_id, { is_completed: sr.is_completed });
            });
            setUserRotaStatusMap(statusMap);
        } catch (error) {
            console.error("Kullanıcı rota durumları çekilirken hata:", error);
            setUserRotaStatusMap(new Map());
        }
    }, [currentUserId]);

    // Rotaları API'den çekme
    const fetchRotalar = useCallback(async () => {
        try {
            setYukleniyor(true);
            setHata(null);

            let apiUrl = `${API_BASE_URL}/rotalar`;
            const params = new URLSearchParams();

            if (secilenIl) {
                const ilAdi = iller.find(il => il.id === secilenIl)?.name;
                if (ilAdi) {
                    params.append('il', ilAdi);
                }
            }
            if (secilenIlce) {
                const ilceAdi = mevcutIlceler.find(ilce => ilce.id === secilenIlce)?.name;
                if (ilceAdi) {
                    params.append('ilce', ilceAdi);
                }
            }

            if (secilenRotaTipi) {
                params.append('filter_type', secilenRotaTipi);
            }

            if (params.toString()) {
                apiUrl += `?${params.toString()}`;
            }

            const token = localStorage.getItem('token');
            const headers = token ? { Authorization: `Bearer ${token}` } : {};

            const response = await axios.get(apiUrl, { headers });
            setTumRotalar(response.data);
            setFiltreliRotalar(response.data);
        } catch (err) {
            setHata('Rotalar yüklenirken bir hata oluştu: ' + (err.response?.data?.detail || err.message));
            console.error('API Hatası:', err);
        } finally {
            setYukleniyor(false);
        }
    }, [secilenIl, secilenIlce, secilenRotaTipi, mevcutIlceler]);

    // Sayfa yüklendiğinde veya filtreler değiştiğinde rotaları ve kullanıcı rota durumlarını çek
    useEffect(() => {
        fetchRotalar();
        fetchUserRotaStatuses(); // Kullanıcı rota durumlarını da çek
    }, [fetchRotalar, fetchUserRotaStatuses]);

    // İl seçimi değiştiğinde ilçe listesini güncelle
    useEffect(() => {
        if (secilenIl) {
            setMevcutIlceler(ilceler[secilenIl] || []);
            setSecilenIlce('');
        } else {
            setMevcutIlceler([]);
            setSecilenIlce('');
        }
    }, [secilenIl]);

return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white p-4 md:p-10">
        <div className="max-w-6xl mx-auto space-y-14">
            {/* Başlık ve Açıklama */}
            <div className="text-center space-y-4">
                <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500">
                    Rota Oluşturucu
                </h1>
                <p className="text-lg text-gray-400 max-w-2xl mx-auto">
                    Keşfetmek istediğin tarihi rotaları bul, kendi rotanı oluştur veya mevcut rotaları düzenle!
                </p>
            </div>

            {/* Filtreleme Alanı */}
            <div className="bg-gray-800 border border-gray-700 rounded-2xl shadow-xl p-6 md:p-8">
                <h2 className="text-2xl font-bold text-teal-400 mb-6">Rotaları Filtrele</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {/* İl Filtresi */}
                    <div className="space-y-2">
                        <label htmlFor="il-secim" className="block text-gray-300 font-medium">İl:</label>
                        <select
                            id="il-secim"
                            value={secilenIl}
                            onChange={(e) => setSecilenIl(e.target.value)}
                            className="w-full bg-gray-900 border border-gray-700 text-gray-200 rounded-lg p-3 focus:outline-none focus:border-teal-500 transition"
                        >
                            <option value="">Tüm İller</option>
                            {Array.isArray(iller) && iller.map(il => (
                                <option key={il.id} value={il.id}>{il.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* İlçe Filtresi */}
                    <div className="space-y-2">
                        <label htmlFor="ilce-secim" className="block text-gray-300 font-medium">İlçe:</label>
                        <select
                            id="ilce-secim"
                            value={secilenIlce}
                            onChange={(e) => setSecilenIlce(e.target.value)}
                            disabled={!secilenIl}
                            className="w-full bg-gray-900 border border-gray-700 text-gray-200 rounded-lg p-3 focus:outline-none focus:border-teal-500 transition disabled:opacity-50"
                        >
                            <option value="">Tüm İlçeler</option>
                            {Array.isArray(mevcutIlceler) && mevcutIlceler.map(ilce => (
                                <option key={ilce.id} value={ilce.id}>{ilce.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            {/* Rota Listesi */}
            <div className="space-y-6">
                <h2 className="text-3xl font-bold text-gray-100">Mevcut Rotalar</h2>

                {yukleniyor && (
                    <div className="flex justify-center items-center h-40 bg-gray-900 border border-gray-700 rounded-xl">
                        <p className="text-lg text-gray-400">Rotalar yükleniyor...</p>
                    </div>
                )}

                {hata && (
                    <div className="flex justify-center items-center h-40 bg-red-900/20 border border-red-800 rounded-xl">
                        <p className="text-lg text-red-400">{hata}</p>
                    </div>
                )}

                {!yukleniyor && !hata && filtreliRotalar.length === 0 && (
                    <div className="flex justify-center items-center h-40 bg-gray-900 border border-gray-700 rounded-xl">
                        <p className="text-lg text-gray-500 italic">Belirtilen kriterlere uygun rota bulunamadı.</p>
                    </div>
                )}

                {!yukleniyor && !hata && filtreliRotalar.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filtreliRotalar.map(rota => {
                            const rotaStatus = userRotaStatusMap.get(rota.id);
                            const isStarted = rotaStatus ? !rotaStatus.is_completed : false;
                            const isCompleted = rotaStatus ? rotaStatus.is_completed : false;
                            return (
                                <RotaKarti 
                                    key={rota.id} 
                                    rota={rota} 
                                    isStarted={isStarted} 
                                    isCompleted={isCompleted} 
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    </div>
);

};

export default RotaOlusturucuSayfasi;